module.exports = __webpack_public_path__ + "static/media/match.513c80e7.svg";